import { render, staticRenderFns } from "./UserPhotoValue.vue?vue&type=template&id=bc467950&scoped=true&"
import script from "./UserPhotoValue.vue?vue&type=script&lang=js&"
export * from "./UserPhotoValue.vue?vue&type=script&lang=js&"
import style0 from "./UserPhotoValue.vue?vue&type=style&index=0&id=bc467950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc467950",
  null
  
)

export default component.exports